import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useMonarchStore from '@/stores/monarchStore';

/* ============================================================================
   Login Page — Monarch luxury styling
   ============================================================================ */

export function LoginPage() {
  const navigate = useNavigate();
  const setAuth = useMonarchStore((s) => s.setAuth);
  const setTenant = useMonarchStore((s) => s.setTenant);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    // Simulated auth
    setTimeout(() => {
      setAuth({
        userId: 'user-1',
        email: email || 'analyst@monarchsa.com',
        displayName: email?.split('@')[0] || 'Monarch Analyst',
        role: 'analyst',
        isAuthenticated: true,
        sessionToken: 'mock-token',
      });

      setTenant({
        tenantId: 'monarch-sa',
        tenantName: 'The Monarch SA',
        slug: 'monarch-sa',
        propertyCode: 'SATMKQQ',
        ga4PropertyId: '', // Will be set from GA4 credentials
      });

      setLoading(false);
      navigate('/overview');
    }, 1000);
  };

  return (
    <div className="min-h-screen bg-bg-0 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-10">
          <img
            src="/logos/monarch-logo.avif"
            alt="The Monarch"
            className="h-16 mx-auto mb-4"
          />
          <h1 className="font-display text-2xl text-text mb-2">
            The Monarch San Antonio
          </h1>
          <p className="text-sm text-text-3">
            Hospitality Intelligence Dashboard
          </p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block text-xs font-medium text-text-3 uppercase tracking-wider mb-2">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="analyst@monarchsa.com"
              className="input-premium"
            />
          </div>

          <div>
            <label className="block text-xs font-medium text-text-3 uppercase tracking-wider mb-2">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="input-premium"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-premium w-full"
          >
            {loading ? (
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Signing in...
              </span>
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-xs text-text-3">
            Powered by Glue42 | Curio Collection by Hilton
          </p>
        </div>
      </div>
    </div>
  );
}
